import React, { useState, useEffect } from 'react';
import SliderHeader from 'jd-library/SliderHeader';
import Button from 'jd-library/Button';
import FormSwitch from 'jd-library/FormSwitch';
import FormRadio from 'jd-library/FormRadio';
import Modal from 'jd-library/Modal';
import Loader from 'jd-library/Loader';
import toastMessageActions from 'jd-library/toastMessageActions'
import withRipple from 'jd-library/withRipple';
import useOnScroll from 'jd-library/useOnScroll';
import CSSTransform from '../../common/transition/Animation';
import { connect, useDispatch } from 'react-redux';
import {useHistory} from 'react-router-dom';
import style from './bulk-upload-slider.scss';
import {uploadFileForBulkUpload, updateHeaderMapping, setCurrentStep, clearBulkUploadData, updateBulkData, toggleBulkProductService} from '../../actions/bulkUpload.js';
import { showToastMessage } from '../../actions/toastmessage';
import FileSelector from '../../common/FileSelector';
import Dropdown from 'jd-library/Dropdown'
import axios from 'axios';
import AnimateSlider from 'jd-library/AnimateSlider';
import BulkUploadHistorySlider from '../bulk-upload-history/BulkUploadHistorySlider'
import { Link , useParams } from "react-router-dom";    
import historyHandler from 'jd-library/historyHandler';
import Popover from 'jd-library/Popover';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel'
import ObjectionalNotify from "../add-edit-product/ObjectionalNotify";
import { setTabStatus, setPreviousTabIndex} from '../../actions/products';
import { getJdMartParams, notifyCatalogueCreated, openPageWithToken } from '../../utills';
import CategorySearchSlider from '../add-edit-product/CategorySearchSlider';
import { identifyAuditFlow } from '../../utills';
import { pageLoad, pageLoadForIos } from '../../common/Utills';
import SellOnlineStep from './SellOnlineStep';
import CategoryWiseBulk from './CategoryWiseBulk';
import BulkDiscountActionModal from './BulkDiscountActionModal';

const p = getJdMartParams().sourceId || '';

const DownloadLink = withRipple((props) => {
    let url = '/marketplace/static/php/web/b2bWebsite.php?token=' + props.session.token + '&action=downloadSamplefile&urlType=downloadFileOmni';
    let sourceFlag=""
    if(props.session.viaOmni){
        sourceFlag="&sourceFlag=1"
    } else{
        sourceFlag="&sourceFlag=2"
    }

    if(props.type == "Service"){
        url+='&bulkType=service';
    }else if(props.transactionType){
        url+='&transactionType='+props.transactionType
    }else if (props.session.newProfile == 4 && !props.bulkUploadServices){
        url+=`&transactionType=receiveenquiry`
    }
    url+=sourceFlag
    const sourceCheck = identifyAuditFlow({query: true});
    const [finalUrl,setFinalUrl] = useState(url);
    const downloadSampleFile = (url) => {
        try {
            console.log('URL : ',url);
            if(props.isJdSourceIOS || props.isJdBusinessIOS){
                url = 'https://download_pdf.php?url='+url;
            }
            if (props.deviceData?.isIphoneApp && window?.webkit?.messageHandlers && window?.webkit?.messageHandlers["downloadFile"]) {
                window.webkit.messageHandlers["downloadFile"].postMessage(window.location.origin+url);
                return true;
            } else {
                if(props.isJdSourceAndroid) {
                    window.JdLiteInterface.openCustomTabDirectly(JSON.stringify({
                        inapp: 3,
                        url: window.location.origin + url
                    }))
                    return;
                }
                window.location.href = url;
            }
        }catch(err) {
            console.log('error -> ',err);
        }
        
    }
    url+=sourceFlag

    const getIosFilePath = async (url) => {
        let iosUrl = await axios.get(url);
        let iosFilePath = iosUrl.data?.filePath;
        setFinalUrl(iosFilePath);
    }
    
    useEffect(()=>{
        if (props.isJdSourceIOS || props.isJdBusinessIOS) {        
            let urlToSend = finalUrl + `&source=${sourceCheck.source}`;
            urlToSend+=sourceFlag
            getIosFilePath(urlToSend);
        }
    },[])
    
    return (
            <Link
                className={`download-link ${props.rippleClass}`}
                {...props.rippleHandler}
                onClick={(e) => downloadSampleFile(finalUrl)}
                key={"download-sample-file"}
        >
            Download
            {props.renderRipple()}
        </Link>
    );
});

export const UploadProductServicePrompt = (props) => {
    return (
        <>
        {!(props.isProductOnlyProfile == 4 && props.transactionType == 'sellonlineNew') && <div className={`${'upload-prod-prompt'} ${props.holderClass}`}>
            <div className='icon-holder'><span className={`${'icon-prod'} ${props.iconClass}`}></span></div>
            <div className='prod-headText'>{props.headerText}</div>
            <Button
                size={'md'}
                className={'upload-btn' + (props.showLoader ? ' with-loader': '')}
                clickHandler={() => {
                    props.transactionType && props.setTransactionType(props.transactionType);
                    if(props.type == 'Service') {
                        !props.bulkUploadServices && props.toggleBulkProductService({
                            bulkUploadServices : true
                        })
                    }else {
                        props.bulkUploadServices && props.toggleBulkProductService({
                            bulkUploadServices : false
                        })
                    }
                    if(props.serviceCatFlow == 'catWiseBulk'){
                        props.setCurrentStep({currentStep: 4})
                        props.showCategoryWiseBulk(true);
                        return;
                    }
                    if((props.type == 'Service' && props.bulkUpload.currentStep != 3) || ['sellonlineNew','receiveenquiryNew'].includes(props.transactionType)){
                        props.setCurrentStep({currentStep: 3})
                        return;
                    }
                    if (props.type != 'Service' && !props.transactionType && props.bulkUpload.currentStep == 1 && props.isProductOnlyProfile == 2){
                        props.setCurrentStep({currentStep: 2})
                        return;
                    }
                    if(props.type != 'Service' && !props.transactionType && props.isProductOnlyProfile == 4 && props.bulkUpload.currentStep == 1){
                        props.setCurrentStep({currentStep: 3})
                        return;
                    }
                    props.uploadBtnClick(props.type == "Service")
                }}
            >
                {props.showLoader ?
                    (
                        <div>
                            <Loader className='upload-btn-loader'/> Uploading
                        </div>
                    ):
                    props.btnText
                }
            </Button>
            {['sellonlineNew','receiveenquiryNew'].includes(props.transactionType) ? 
                null
                :
                <div className={'sample-download '+props.type}>
                    {props.catInfoText ? props.catInfoText
                    :
                        (!props.transactionType && props.bulkUpload.currentStep != 3?`Select this Option for Uploading ${props.type}s`:
                        <>
                            <DownloadLink {...props} /> 
                            {" "+props.type+" "} 
                            Sample Excel (.xlsx) Template
                        </>)
                    }
                </div>
            }
        </div>}
        </>
    )
}

const TransactionType = (props) => {
    return (
        <>
            <div className='upload-prompt'>
                {(Number(props.isProductOnlyProfile) != 1) ?<UploadProductServicePrompt
                    {...props}
                    iconClass = {"icon-message"}
                    headerText = {"Bulk Upload Products to Receive Enquiry"}
                    btnText = {"Upload Products"}
                    type = {"Product"}
                    showLoader = {props.showLoader == 'product' && props.transactionType == 'receiveenquiry'}
                    transactionType={"receiveenquiryNew"}
                    holderClass={"receiveenquiry-bold-icon"}
                /> : null}
                {props.isProductOnlyProfile ? <UploadProductServicePrompt
                    {...props}
                    holderClass = {"service-holder"}
                    iconClass = {"icon-HDRcart"}
                    headerText = {"Bulk Upload Products to Sell Online"}
                    btnText = {"Upload Products"}
                    type = {"Product"}
                    showLoader = {props.showLoader == 'product' && props.transactionType == 'sellonline'}
                    transactionType={"sellonlineNew"}
                />:null}
            </div>
        </>
    )
}


const UploadPrompt = (props) => {
    return (
        <>
        <div className='upload-prompt'>
            {Number(props.isProductOnlyProfile) == 3 ?
                null:
                <UploadProductServicePrompt
                    {...props}
                    iconClass = {"icon-Product"}
                    headerText = {"Bulk Upload Products"}
                    btnText = {"Upload Products"}
                    type = {"Product"}
                    showLoader = {props.showLoader == 'product'}
                />
            }
            {Number(props.isProductOnlyProfile) == 2 || Number(props.isProductOnlyProfile) == 3 || Number(props.isProductOnlyProfile) == 4 ?<UploadProductServicePrompt
                {...props}
                holderClass = {"service-holder"}
                iconClass = {"icon-AddService"}
                headerText = {"Bulk Upload Services"}
                btnText = {"Upload Services"}
                type = {"Service"}
                showLoader = {props.showLoader == 'service'}
            />:null}
        </div>
        </>
    )
}

const PopoverWithToggle = (props) => {
    let popoverDivRef = React.useRef(null);
    let popoverText = props.value + ' will be used to match product details present in Product Library and if found, the system will automatically enrich the product information with formatted name, category, images, specifications and description.';
    let toggleVal = props.value == 'Barcode' ? props.updateViaBarcode : props.updateViaProdName;
    return(
        <div className='barcode-div' ref={popoverDivRef}>
            <div className='barcode-info'>
                Auto Update Product Information by Matching <span>{props.value}</span>
                <Popover
                    content={<div>{popoverText}</div>}
                    containerEle={popoverDivRef}
                >
                    <div className={'popover-icon-div'}>
                        <i className='popover-icon icon-Info'></i>
                    </div>
                </Popover>
            </div>
            <div className='barcode-toggle'>
                <FormSwitch
                    checked={toggleVal}
                    onChange={(e) => {
                        props.setAutoUpdateProdInfo(e.target.checked, props.value);
                    }}
                    variant='secondary'
                    className='input-row label-row'
                    labelPosition='before'
                />
            </div>
        </div>
    )
}

const MapFields = (props) => {
    let list = [];
    if (props.optionsList){
        for (let i = 0; i < props.optionsList.length; i++) {
            list.push({
                label: props.optionsList[i],
                key: props.optionsList[i]
            })
        }
    }
    let refArray = [];
    const handleChange = (e, key, ref) => {
        props.handleChange(e, key);
    }
    const renderSelected = (item) => {
        return (
            <div className={`${style['custom-option']} ${style['selected']}`}>
                {item.label}
            </div>
        )
    }
    let [clickDisable, setClickDisable] = React.useState({
        index: -1,
        state: false
    });
    const onToggle = (state, index) => {
        let tempArr = {};
        if (clickDisable['state'] != state) {
            tempArr = {
                index: index,
                state: state
            };
            setClickDisable(tempArr);
        }
    }
    const alreadyApplied = (item, value) => {
        console.log(item);
        console.log(value);
        if ([value,'Specification','Additional Image Link',"Don't Map This Field", "Dont map this field", "Custom field"].indexOf(item.label) != -1) {
            return false;
        }
        else if (Object.values(props.bulkUpload.headerMapping).indexOf(item.key) != -1) {
            return true;
        }
        return false;
    }
    let fieldsData = Object.keys(props.fieldsData);
    if(props.isMapCategory){
        fieldsData = props.bulkUpload.categoryData;
    }
    return (
        <div className='map-field-div'>
            <div className='map-field-header'>
                {
                    props.bulkUpload.isMapPackaging ? 
                    'Map Product Packaging to Omni System Units': 
                    props.isMapCategory ? 
                    'Map Your Categories to Relevant Jd Mart Categories' : 
                    `Map Column Name to ${props.bulkUploadServices ? 'Service' : 'Product'} Field`
                }
            </div>
            <div className='all-fields'>{
                fieldsData.map((key, index) => {
                    let value = props.bulkUpload.headerMapping[key] || "Don't Map This Field";
                    if(key.indexOf('Blank') != -1 && key.indexOf('Column') != -1){
                        return;
                    }
                    if(props.isMapCategory){
                        if(key["isMatchFound"]===1){
                            return;
                        }
                        value = key["matchedLeafName"] ? key["matchedLeafName"] : "Select Category"
                    }
                    let minHeight = 0, modifiedList = [];
                    for (let i = 0; i < list.length; i++) {
                        if (!alreadyApplied(list[i], value)) {
                            minHeight += 45;
                            modifiedList.push(list[i]);
                        }
                    }
                    let clickDisableForCurrent = (clickDisable['index'] != index && clickDisable['state']);
                    return (
                        <div className={`single-field ${value == 'Barcode' ? 'with-toggle':''}`}>
                            <div className='map-label'>
                                {props.isMapCategory ? key["leafName"] : key}
                                {/* <span className='example'> : Eg. {props.bulkUpload.sampleRow[index]}</span> */}
                            </div>
                            {props.isMapCategory ? 
                            <div className='category-field' onClick={()=>{props.openCatSlider(index)}}>
                                <InputWithMovingLabel 
                                    holderClass={`single-field-input ${key["matchedLeafName"] ? '' : 'unmatched-cat'}`}
                                    label='Map To'
                                    ref={ref => (refArray[index] = ref)}
                                    showArrow={true}
                                    input={{
                                        value
                                    }}
                                    errorMessage={key.errorMessage}
                                />
                            </div> : 
                            <Dropdown
                                className={`single-field-input ${clickDisableForCurrent ? 'click-disable': ''}`}
                                optionList={modifiedList}
                                dropdownClass={'min-height-' + minHeight}
                                label='Map To'
                                ref={ref => (refArray[index] = ref)}
                                onChange={(e, value) => {
                                    handleChange(e, key)
                                }}
                                onToggle={(evt, state) => {onToggle(state, index)}}
                                renderItem={(item)  => {
                                    if (alreadyApplied(item, value)){
                                        return null
                                    }
                                    return (
                                        <div className={style['custom-option']}>
                                            <span className='option-label'>{item.label}</span>
                                        </div>
                                    )}
                                }
                                renderSelected={renderSelected}
                                value={value}
                            ></Dropdown>}
                            {((value == 'Barcode') || (value == 'Product Name' && props.isVendorImport)) && <PopoverWithToggle {...props} value={value} />}
                        </div>
                    )
                })
            }</div>
            {/* <div className='upload-prod'>
                <Button
                    onClick={props.onBtnClick}
                    raised
                    size='lg'
                >
                    Upload Products
                </Button>
            </div> */}
        </div>
    )
}


const UploadProgress = (props) => {
    
    const [percValue, setPercValue] = useState(0);
    const [uploadStatus, setUploadStatus] = useState('PENDING');
    const [errorFileLink, setErrorFileLink] = useState('');
    const [showDiscntBtn, setDiscntBtn] = useState(false);
    const [count, setCount] = useState({});
    const clickedProfile =  props?.bulkUploadServices ? 'service' : 'product'
    const isProductOnlyProfile = props.session?.newProfile;
    const profileObject = props.session?.profileObject
    let tempVal;
    if(props.currentStep == 6 && !props.bulkUpload.fieldId && !props.bulkUpload.mongoId){
        props.setCurrentStep({currentStep:0});   
    }
    let url = '/marketplace/static/php/web/b2bWebsite.php?token='+ props.session.token +'&action=uploadProgress&fileId=' + props.bulkUpload.fileId+'&jobId='+props.bulkUpload.mongoId;
    if(props.bulkUploadServices){
        url+='&bulkType=service';
    }
    let sourceFlag=""
    if(props.session.viaOmni){
        sourceFlag="&sourceFlag=1"
    } else{
        sourceFlag="&sourceFlag=2"
    }
    url+=sourceFlag
    const getIosFilePath = async (url) => {
        let iosUrl = await axios.get(url);
        let iosFilePath = iosUrl.data?.filePath;
        setErrorFileLink(iosFilePath);
    }
    const updateLoader = () => {
        axios({
            method: 'GET',
            url: url
        }).then((res) => {
            console.log(res,'bulk upload file response')
            let status = res.data.status || res.data.jobStatus;
            if (res.data.isFirstProduct && [23].includes(props.session.jdSource)){
                notifyCatalogueCreated();
            }
            if (status == 'UPDATE_FAILED') {
                status = 'FAILED'
            }
            if (status == 'COMPLETED') {
                status = 'DONE'
            }
            if (status == 'UPDATING' || status =='VALIDATING') {
                status = 'PENDING'
            }
            if (status == 'PARTIALLY_COMPLETED') {
                status = 'PARTIAL'
            }
            if (status != 'PENDING' && status != 'STARTED') {
                setUploadStatus(status);
                let errorUrl = '/marketplace/static/php/web/b2bWebsite.php?token=' + props.session.token + '&urlType=downloadFileOmni&action=downloadErrorFile&errorFileId=' + props.bulkUpload.mongoId;
                if(props.bulkUploadServices){
                    errorUrl+='&bulkType=service';
                }
                errorUrl+=sourceFlag
                setErrorFileLink(errorUrl);
                let completionPercentage = res.data.completionPercentage;
                if (status == 'DONE' || status == 'PARTIAL' || status == 'FAILED') {
                    completionPercentage = 100;
                }
                if (props.isJdSourceIOS || props.isJdBusinessIOS) {        
                    let urlToSend = errorUrl + `&source=${sourceCheck.source}`;
                    getIosFilePath(urlToSend);
                }
                if(status == 'DONE'){
                    let params = new URLSearchParams(location.search.substring(1));
                    let fromWalkthrough = params.get("fromWalkthrough");
                    if (fromWalkthrough && fromWalkthrough == 'true') {
                        axios({
                            method: 'GET',
                            url: '/marketplace/static/php/web/walkThroughApi.php?action=updateStatus'
                        }).then((res) => { })
                    }
                }
                if((status == 'DONE' || status == 'PARTIAL')){
                    if(res.data.discount_data && (props.session.viaOmni ? !props.bulkUploadServices : true)){
                        props.toggleBulkDiscountModal({
                            show: true,
                            data: res.data.discount_data
                        })
                        setDiscntBtn(true);
                    }
                }
                setCount({
                    totalCnt: res.data.totalCnt,
                    doneCnt: res.data.doneCnt,
                    greyListCnt: res.data.greyListCnt || 0
                })
                if (status == 'PARTIAL' || status == 'FAILED'){
                    props.setUploadFailed(true)
                }
                if(props.bulkUpload.currentStep == 5) {
                    props.setCookie('currentStep', '');
                    props.setCookie('fileId', '');
                    props.setCookie('mongoId', '');
                    props.setCookie('type', props.bulkUploadServices ? 'service' : 'product');
                    if (status == 'FAILED') {
                        props.setCurrentStep({currentStep: 6});
                    }
                    else{
                        setPercValue(100);
                        props.updateBulkStatus && props.updateBulkStatus(true);
                        circleRef && circleRef.current && (circleRef.current.style.strokeDashoffset = 0);
                        setTimeout(() => {
                            props.setCurrentStep({currentStep: 6});
                        }, 1000);
                    }
                }
                return;
            }
            let completionPercentage;
            tempVal = res.data.percentage;
            if(completionPercentage){
                tempVal = completionPercentage;
            }
            var rad = 38;
            var pct, cf = Math.PI*(rad*2);
            if (tempVal < 0) {
                tempVal = 0;
            }
            else if(tempVal > 100) {
                tempVal = 100;
            }
            if(isNaN(Math.round(tempVal))) {
                tempVal = 0;
            }
            pct = ((100 - tempVal)/100)*cf;
            setPercValue(tempVal);
            circleRef && circleRef.current && (circleRef.current.style.strokeDashoffset = pct);
            setTimeout(() => {
                updateLoader();
            }, 1000);
        })
    }
    useEffect(() => {
        updateLoader();
    }, []);
    let circleRef = React.useRef(null);
    if (props.currentStep == 5){
        return (
          <div className="uploading-file">
            <div id="cont" data-pct="100">
              <svg id="svg" width="5rem" height="5rem" viewPort="0 0 2.5rem 2.5rem" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <circle r="38" cx="2.5rem" cy="2.5rem" fill="transparent" stroke-dasharray="239" stroke-dashoffset="0" ></circle>
                <circle ref={circleRef} id="bar" r="38" cx="2.5rem" cy="2.5rem" fill="transparent" stroke-dasharray="239" stroke-dashoffset={239} ></circle>
              </svg>
              <div className="catalogue-percentage">
                {Math.round(percValue)}%
              </div>
            </div>
            <div className="prog-heading">
              {`${props.bulkUploadServices ? "Service" : "Product"} Upload in Progress`}
            </div>
            {
              <div className="prog-sub-heading with-continue">
                <div className="mgb-15">
                  This may take few minutes. You can continue using the system while the upload is in progress.
                </div>
                <div className="mgb-15">
                  You can check the status of upload by clicking on{" "}
                  <i className="icon-glHistory" /> in Bulk Upload{" "}
                  {props.session.bulkUploadProfile == 1
                    ? "Service"
                    : ([2, 4].includes(isProductOnlyProfile)
                        ? "Product/Service"
                        : [0, 1].includes(isProductOnlyProfile)
                        ? "Product"
                        : "Service") || ""}{" "}
                  section.
                </div>
                <Button size="lg" className="continue-btn" clickHandler={props.sendToFirstStep}>
                  Continue
                </Button>
              </div>
            }
          </div>
        );
    }
    let showObjectionalNote = (count && count.greyListCnt > 0) ? true : false;
    const downloadErrorFile = (errorFileUrl) => {
        if(props.isJdSourceIOS || props.isJdBusinessIOS){
            errorFileUrl = 'https://download_pdf.php?url='+errorFileUrl; 
        }
        errorFileUrl+=sourceFlag
        window.location.href = errorFileUrl;
    }
    return (
        <div className='upload-progress'>
            <div className='status-icon'>
                {uploadStatus == 'DONE' && <i className='icon-Checkmark success'></i>}
                {uploadStatus == 'PARTIAL' && <i className='icon-alert_outline2 partial-success'></i>}
                {uploadStatus == 'FAILED' && <i className='icon-alert_outline2 failed'></i>}
            </div>
            <div className='status-heading'>
                {uploadStatus == 'DONE' ? `${props.bulkUploadServices ? 'Services' : 'Products'} Uploaded Successfully`:null}
                {uploadStatus == 'PARTIAL' ? `${props.bulkUploadServices ? 'Services' : 'Products'} Partially Uploaded`:null}
                {uploadStatus == 'FAILED' ? `${props.bulkUploadServices ? 'Services' : 'Products'} Upload Failed`:null}
            </div>
            {(uploadStatus == 'PARTIAL' || uploadStatus == 'FAILED') &&
                <>
                    <div className='status-sub-heading'>
                        {uploadStatus == 'PARTIAL' && <div className='partial-count'>{count.doneCnt}/{count.totalCnt} {`${props.bulkUploadServices ? 'Services' : 'Products'} Uploaded`}</div>}
                        {(uploadStatus == 'PARTIAL') ? <div className='mgb-22'>
                            {`Please note that images for the uploaded ${props.bulkUploadServices ? 'services' : 'products'} are being fetched from the uploaded links and will be shown against the ${props.bulkUploadServices ? 'service' : 'product'} in sometime.`}
                        </div> : null}
                        <div className='steps-header'>Please follow the steps given below to rectify the error</div>
                        <div className='steps'>
                            <div>1. Download Error File</div>
                            <div>2. Correct the Errors in the Downloaded File</div>
                            <div>3. Reupload the Updated File</div>
                        </div>
                    </div>
                    {
                        showObjectionalNote ? (
                            <ObjectionalNotify isBulkUpload = {true} newProfile={isProductOnlyProfile} selectedType={clickedProfile}  />
                        ) : null
                    }
                    <Button
                        size='lg'
                        className='progress-btn error-file'
                        onClick={()=>downloadErrorFile(errorFileLink)}
                    >
                        Download Error File
                    </Button>
                </>
            }
            {(uploadStatus == 'DONE') ? 
                <div className='status-sub-heading'>
                    {`Please note that images for the uploaded ${props.bulkUploadServices ? 'services' : 'products'} are being fetched from the uploaded links and will be shown against the ${props.bulkUploadServices ? 'service' : 'product'} in sometime.`}
                </div> : null
            }
            {uploadStatus == 'DONE' && (<>
                {
                    showObjectionalNote ? (
                        <ObjectionalNotify isBulkUpload = {true} newProfile={isProductOnlyProfile} selectedType={clickedProfile}  />
                    ) : null
                }
                {props?.selectTypeQuery?.closeIframe != '1' ? 
                <Button
                    size='lg'
                    className='view-prod-btn progress-btn'
                    clickHandler={() => {
                        if(props?.selectTypeQuery?.closeIframe == 1) {
                            parent?.callback && parent?.callback?.fn();
                            let ele = parent?.document.getElementById('omniIframe');
                            parent.document.body.style.overflow = 'unset';
                            if(ele?.parentNode && ele?.parentNode?.children && ele?.parentNode?.children?.length){
                                ele.parentNode.removeChild(ele);
                            }
                            return;
                        }
                        props.toggleRedirectToProducts(false);
                        props.setTabStatus({label: ''})
                        props.setPreviousTabIndex({tabIndex: 0})
                        window.history.back();
                    }}
                >
                    {`View ${props.bulkUploadServices ? 'Services' : 'Products'}`}
                </Button>
                : null}
                </>
            )
            }
            <Button
                variant='default'
                size='lg'
                className='upload-another progress-btn'
                clickHandler={props.sendToFirstStep}
            >
                Upload Another File
            </Button>
            {(uploadStatus == 'PARTIAL') ? (<>
                <Button
                    variant='default'
                    size='lg'
                    className='view-product-partial progress-btn'
                    clickHandler={() => {
                        props.toggleRedirectToProducts(false);
                        props.setTabStatus({label: ''});
                        props.setPreviousTabIndex({tabIndex: 0})
                        window.history.back();
                    }}
                >
                    {`View ${props.bulkUploadServices ? 'Services' : 'Products'}`}
                </Button>
                </> 
            ) : null
            }
            {(uploadStatus == 'DONE' || uploadStatus == 'PARTIAL') && showDiscntBtn && (props.session.viaOmni ? !props.bulkUploadServices : true) ?
                <Button
                    size='lg'
                    variant='default'
                    className='view-prod-btn discount-list-btn progress-btn'
                    clickHandler={() => {
                        let bulkDiscntUrl = `/marketplace/static/php/web/b2bBulkUploadDiscount.php?action=downloadDiscountFile&discountFileId=${props.bulkUpload.mongoId}&token=${props.session.token}`;
                        downloadErrorFile(bulkDiscntUrl)
                    }}
                >
                    {
                        <>
                            <div>Download Discounted Products List</div>
                            <div className="dis-more-text">(More than 25% Discount)</div> 
                        </>
                    }
                </Button>
                : null
            }    
        </div>
    )
}

const SingleOutlet = withRipple((props) => {
    let outlet = props.outlet || {};
    return (
        <div className={`outlet ${props.rippleClass}`} onClick={() => {props.handleChange(outlet.id)}} {...props.rippleHandler}>
            <div className='radio'>
                <FormRadio 
                    className={'radio-input'}
                    checked={outlet.id == props.selectedOutletId}
                />
            </div>
            <div className='outlet-data'>
                <div className='name'>{outlet.name}</div>
                <div className='area'>{outlet.area}</div>
            </div>
            {props.renderRipple()}
        </div>
    );
});

const OutletSelectDiv = (props) => {
    if(!props.outletData || (props.outletData && !props.outletData.length)) {
        return null;
    }
    const handleChange = (id) => {
        props.setSelectedOutletId && props.setSelectedOutletId(id);
    }
    return (
        <div className='outlet-select-div'>
            <div className='outlet-select-title'>
                Select Outlet for Bulk Upload
            </div>
            <div className='outlet-select-options'>
                {props.outletData.map((outlet) => {
                    return (
                        <SingleOutlet
                            outlet={outlet}
                            selectedOutletId={props.selectedOutletId}
                            handleChange={handleChange}
                        />
                    )
                })}
            </div>
        </div>
    )
}

const BulkUploadSlider = (props) => {
    const history = useHistory();
    const params = useParams();
    let selectTypeQuery = identifyAuditFlow({ query: true });
    const [historySliderOpen,updateHistorySlider] = useState(false);
    const [isMapCategory, setIsMapCategory] = useState(false);
    const [showCatSlider, setCatSlider] = useState({show: false});
    const [bulkDiscountModal, toggleBulkDiscountModal] = useState({show: false});
    let outletId = (props.outletData && props.outletData[0]) ? props.outletData[0].id: '';
    const [selectedOutletId, setSelectedOutletId] = React.useState(outletId);
    const isProductOnlyProfile = props.session?.newProfile;
    const profileObject = props.session?.profileObject
    const historyListenerRef = React.useRef(null);
    const [bypassScreen,setBypassScreen]  = useState(false) 
    let sourceFlag=""
    if(props.session.viaOmni){
        sourceFlag="&sourceFlag=1"
    } else{
        sourceFlag="&sourceFlag=2"
    }
    let leftIcons = [
        {
            className:'icon-hdrBackNew',
            onClick: () => {
                let endPoint = 1;
                switch (isProductOnlyProfile) {
                    case 0: 
                        endPoint = 2;
                        break;
                    case 1:
                        endPoint = 2;
                        break;
                    case 2:
                        endPoint = 1;
                        break;
                    case 3:
                        endPoint = 1;
                        break;
                } 
                if(props.isB2BMobile && props.bulkUpload.currentStep == 1) {
                    redirectedToProducts.current = false;
                }
                if(props.bulkUpload.currentStep == 4){
                    // props.updateBulkData({currentStep: 2, isMapPackaging: false});
                    showCategoryWiseBulk(false);
                    props.setCurrentStep({currentStep: 3});
                } else if(props.bulkUpload.currentStep == 4 && isProductOnlyProfile == 3){
                    props.setCurrentStep({currentStep: 0});
                }else if(props.bulkUploadServices && props.bulkUpload.currentStep == 3 && !props.session.bulkUploadProfile) {
                    props.setCurrentStep({currentStep: 1});
                }else if (props.bulkUploadServices && props.bulkUpload.currentStep == 3 && props.session.bulkUploadProfile == 1){
                    window.history.go(-2)
                }
                else if((props.bulkUpload.currentStep != endPoint) && props.bulkUpload.currentStep != 5){
                    if(props.bulkUpload.currentStep == 3 && isProductOnlyProfile == 4){
                        props.setCurrentStep({currentStep: 1})
                    }else if (props.bulkUpload.currentStep == 3 && [0, 1, 3].includes(isProductOnlyProfile)) {
                        if (bypassScreen) {
                            window.history.go(-2)
                        } else {
                            window.history.back();
                        }
                    } else {
                        props.setCurrentStep({ currentStep: props.bulkUpload.currentStep - 1 })
                    }
                }else if((props.isJdSourceAndroid || props.isJdBusinessIOS) && selectTypeQuery.fromSeller === 'true'){
                    window.location.href = 'https://jdext.php'
                }else if(props.bulkUpload.currentStep == endPoint){   
                    window.history.back();
                }else if(props.bulkUpload.currentStep == 5) {
                    handleBack('',true);
                    window.history.back();
                }
                // if(props.bulkUpload.currentStep == 4 && isProductOnlyProfile != 2){
                //     // props.updateBulkData({currentStep: 2, isMapPackaging: false});
                //     if(Number(isProductOnlyProfile) == 0){
                //         props.setCurrentStep({currentStep: 3});
                //     }else{
                //         showCategoryWiseBulk(false);
                //         props.setCurrentStep({currentStep: 3});
                //     }
                // }else if(props.bulkUpload.currentStep == 3){
                //     props.setCurrentStep({currentStep: 2});
                // }
                // else if(props.bulkUpload.currentStep == 4 && isProductOnlyProfile == 2){
                //     showCategoryWiseBulk(false);
                //     props.setCurrentStep({currentStep: 3});
                // }else if((props.isJdSourceAndroid || props.isJdBusinessIOS) && selectTypeQuery.fromSeller === 'true'){
                //     window.location.href = 'https://jdext.php'
                // }else{
                //     window.history.back();
                // }
            }
        }
    ], rightIcons = [
        {
            className: 'icon-glHistory',
            onClick: () => {
                updateHistorySlider(true);
            }
        }
    ], leftIconsWeb = ([1,3].includes(isProductOnlyProfile)) && (props.bulkUpload.currentStep == 2) ? [] : (props.bulkUpload.currentStep == 1 || (isProductOnlyProfile == 0 && props.bulkUpload.currentStep == 2)) ? [
    {
            className: 'icon-glHistory',
            onClick: () => {
                updateHistorySlider(true);
            }
        }
    ]: [
        {
            className: 'icon-HDRback',
            onClick: () => {
                if(props.bulkUpload.currentStep == 4){
                    // props.updateBulkData({currentStep: 2, isMapPackaging: false});
                    if(Number(isProductOnlyProfile) == 0){
                        props.setCurrentStep({currentStep: 2});
                    }else{
                        showCategoryWiseBulk(false);
                        props.setCurrentStep({currentStep: 3});
                    }
                }else if(props.bulkUpload.currentStep == 4 && isProductOnlyProfile == 2){
                    showCategoryWiseBulk(false);
                    props.setCurrentStep({currentStep: 0});
                }
                else if (props.bulkUpload.currentStep == 1) {
                    props.onHidden && props.onHidden();
                }else if(props.bulkUpload.currentStep == 3) {
                    if(!props.bulkUpload.bulkUploadServices && (isProductOnlyProfile == 2)){
                        props.setCurrentStep({currentStep: 2});
                    }else if (props.bulkUpload.bulkUploadServices && (isProductOnlyProfile == 2)){
                        props.setCurrentStep({currentStep: 1});
                    }else if((isProductOnlyProfile == 4)){
                        props.setCurrentStep({currentStep: 1});
                    }else{
                        setBackAgain(false);
                        props.setCurrentStep({currentStep: 0});
                        props.onHidden && props.onHidden();
                        props.clearBulkUploadData && props.clearBulkUploadData();
                        historyHandler.closeAll();
                    }
                }else if(props.bulkUpload.currentStep == 5) {
                    setBackAgain(false);
                    props.setCurrentStep({currentStep: 0});
                    props.onHidden && props.onHidden();
                    props.clearBulkUploadData && props.clearBulkUploadData();
                    if((props.isJdSourceAndroid || props.isJdBusinessIOS) && selectTypeQuery.fromSeller === 'true'){
                        window.location.href = 'https://jdext.php';
                    }
                    historyHandler.closeAll();
                }
                else {
                    props.setCurrentStep({currentStep: props.bulkUpload.currentStep - 1})
                }
            }
        }
    ],
    rightIconsWeb =  (Number(isProductOnlyProfile) == 1 && props.bulkUpload.currentStep == 3) || 
    (Number(isProductOnlyProfile) == 2 && (!props.session.viaOmni) && (props.bulkUpload.currentStep == 3 || props.bulkUpload.currentStep == 2) 
    || (props.session.viaOmni && ![1,2,3,4,5,6].includes(props.bulkUpload.currentStep))
    ) ?
        [
            {
                className: 'icon-glHistory',
                onClick: () => {
                    updateHistorySlider(true);
                }
            }
        ] 
        :
        [
            {
                className: 'icon-HDRcross',
                onClick: () => {
                    if(selectTypeQuery?.closeIframe == '1') {
                        let ele = parent?.document.getElementById('omniIframe');
                        parent.document.body.style.overflow = 'unset';
                        if(ele?.parentNode && ele?.parentNode?.children && ele?.parentNode?.children?.length){
                            ele.parentNode.removeChild(ele);
                        }
                        return;
                    }
                    setBackAgain(false);
                    props.setCurrentStep({currentStep: 0});
                    props.onHidden && props.onHidden();
                    props.clearBulkUploadData && props.clearBulkUploadData();
                    if((props.isJdSourceAndroid || props.isJdBusinessIOS) && selectTypeQuery.fromSeller === 'true'){
                        window.location.href = 'https://jdext.php';
                    }
                    historyHandler.closeAll();
                }
            }
        ];
    let accept = '.xls, .xlsx';
    let fileSelector = React.useRef(null);
    const redirectedToProducts = React.useRef(true);
    const [backAgain, setBackAgain] = useState(true);
    const saveOutlet = () => {
        props.updateBulkData({
            currentStep: 1,
            selectedOutletId : selectedOutletId
        })
        historyHandler.pushState(history, 'skip-outlet');
    }
    const animateAgain = () => {
        setNoAnimate(true);
        setTimeout(() => {
            setNoAnimate(false);
            setBackAgain(true);
        }, 100);
    }
    useEffect(() => {
        !selectedOutletId && setSelectedOutletId((props.outletData && props.outletData[0]) ? props.outletData[0].id: '');
        if(props.outletData && props.outletData.length == 1 && !props.bulkUpload.selectedOutletId) {
            props.updateBulkData({selectedOutletId: props.outletData[0].id});
        }
    }, [props.outletData]);
    let isOutletSelectRequired = (props.outletData && props.outletData.length > 1);
    const skipToUpload = () => {
        let selectedOutletId = props.bulkUpload.selectedOutletId;
        setTimeout(() => {
            if(props.outletData && props.outletData.length > 1) {
                props.updateBulkData({currentStep: 1, selectedOutletId: selectedOutletId});
                historyHandler.pushState(history, 'skip-outlet');
                animateAgain();
            }
        }, 100);
    }
    const handleBack = (state, sendToFirst) => {
        // setTimeout(() => {
            if(categoryWiseBulk && props.bulkUpload.currentStep == '4'){
                return;
            }
            if(props.isVendorImport && props.outletData && props.outletData.length > 1) {
                if(!backAgain) {
                    return;
                }
                if (props.bulkUpload.currentStep > 2){
                    window.history.go(-2);
                    if(sendToFirst) {
                        setBackAgain(false);
                        props.clearBulkUploadData();
                        skipToUpload();
                    }
                }
                else if (state && state.includes('skip-outlet')){
                    props.clearBulkUploadData();
                }
                else if (state && state.includes('bulk-upload-step-2') && !sendToFirst){
                    if(props.bulkUpload.isMapPackaging){
                        props.updateBulkData({currentStep: 2, isMapPackaging: false});
                        return;    
                        //From map packaging page, go to Map column to field page.
                    }
                    props.updateBulkData({currentStep: 1, isMapPackaging: false})
                }
                return;
            }
            if(props.isVendorImport && props.outletData && props.outletData.length == 1) {
                if (props.bulkUpload.currentStep > 2){
                    window.history.back();
                    if(sendToFirst) {
                        setBackAgain(false);
                        props.clearBulkUploadData();
                        animateAgain();
                    }
                }
                else if (state && state.includes('bulk-upload-step-2')){
                    //props.clearBulkUploadData();
                    if(props.bulkUpload.isMapPackaging){
                        props.updateBulkData({currentStep: 2, isMapPackaging: false});
                        return;    
                        //From map packaging page, go to Map column to field page.
                    }
                    props.updateBulkData({currentStep: 1, isMapPackaging: false})
                    //Go to step 1 but retain data about outletId
                }
                return
            }
            if(state && state.includes('map-categories-slider')){
                return;
            }
            if (state && state.includes('bulk-upload-step-2') && !sendToFirst){
                setIsMapCategory(false);
                return;
            }
            if(props.bulkUpload.currentStep == 5 && backAgain){
                if(!props.deviceData.isMobile){
                    closeSlider();
                }else{
                    window.history.back();
                }
                return;
            }
            if (props.bulkUpload.currentStep !=4){
                setTimeout(() => {
                    props.updateBulkData({currentStep: 3, isMapPackaging: false})
                })
            }

            if(props.isB2BMobile && props.bulkUpload.currentStep > 5 && backAgain){
                if(sendToFirst){
                    // closeSlider();
                    history.goBack();
                    return;
                }
            }
            if (!props.isVendorImport && (props.bulkUpload.currentStep == 1 || !backAgain || !redirectedToProducts.current)) {
                if(props.isB2BMobile) {
                    historyListenerRef.current && historyListenerRef.current();
                    if(history.location.pathname.indexOf('products') == -1 && !redirectedToProducts.current) {
                        historyListenerRef.current = history.listen((location, action) => {
                            if (action === 'PUSH') {
                                return;
                            }
                            if (action === 'POP') {
                                if(location.pathname.indexOf('products') == -1) {
                                    history.goBack();
                                }
                            }
                        });
                        history.goBack();
                        return;
                    }
                } else {
                    closeSlider();
                    return;
                }
            }
            // if (props.bulkUpload.currentStep > 2 && backAgain){
            //     setBackAgain(false);
            //     setNoAnimate(true);
            //     setTimeout(() => {
            //         setNoAnimate(false);
            //     }, 100);
            //     !sendToFirst && window.history.back();
            // }
        // }, 100);
    };
    const [nameValidationModal, setNameValidationModal] = useState(false);
    const [modalData,setModalData] = useState({});
    const [transactionType,setTransactionType] = useState('')
    const [showChooseFileLoader, setChooseFileLoader] = useState(false);
    const [categoryWiseBulk, showCategoryWiseBulk] = useState(false);
    const [catData, setCatData] = useState('');
    const [sliderShown,updateSliderFlag] = useState(false);
    const [isScroll, setScroll] = useState(false);
    const [isUploadBtnLoader, setUploadBtnLoader] = useState(false);
    const [isFailed, setIsFailed] = useState(false);
    const [noAnimate, setNoAnimate] = useState(false);
    const dispatch = useDispatch();
    const handleChange = (e, fieldId) => {
        let tempData = props.bulkUpload.headerMapping;
        tempData[fieldId] = e.key;
        props.updateHeaderMapping(tempData);
    }
    const deleteCookie = (name) =>{
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
    const setCookie = (name, value) => {
        if(document.cookie.includes((name+'='))){
            deleteCookie(name);
        }
		var date = new Date();
		date.setDate(date.getDate() + 365);
		document.cookie = name + '=' + value + ';expires=' + date.toUTCString()+'path=/';
    }
    const getCookie = (name) => {
        if (document.cookie.includes((name+'=')) ){
            let splitVal = document.cookie.split((name+'='))[1];
            if (splitVal){
                return splitVal.split(';')[0];
            }
            else{
                return '';
            }
        }
        return '';
    }
    const initialisePhpSession = () => {
        return axios.get("/marketplace/static/php/web/common_api.php?action=startSession");
    }
    const getCategoryMappingData = () => {
        setUploadBtnLoader(true);
        axios.get("/marketplace/static/php/web/b2bWebsite.php?token="+props.session.token+"&action=getCategoryMappingForFile&fileId="+props.bulkUpload.fileId)
        .then((res)=>{
            let categoryMap = {};
            let categoryData = res.data.categoryData;
            let isMatchFound = true;
            for(let i=0;i<categoryData.length;i++){
                if(!categoryData[i].isMatchFound){
                    isMatchFound = false;
                    break;
                }
                categoryMap[categoryData[i].leafName] = categoryData[i].leafId;
            }
            if(isMatchFound){
                //Call Service Directly.
                let url = '/marketplace/static/php/web/b2bWebsite.php?token=' + props.session.token + '&action=updateHeaderMapping&fileId=' + props.bulkUpload.fileId +'&headerMapping='+ encodeURIComponent(JSON.stringify(props.bulkUpload.headerMapping));
                url+=sourceFlag
                axios({
                    method: 'POST',
                    url: url,
                    data: {
                        categoryMap: categoryMap
                    },
                }).then((res) => {
                    setUploadBtnLoader(false);
                    setCookie('currentStep', '3');
                    setCookie('fileId', (''+props.bulkUpload.fileId));
                    setCookie('type', props.bulkUploadServices ? 'service' : 'product');
                    props.setCurrentStep({currentStep: 4});
                })
            }else{
                //Open Category Mapping Slider
                setUploadBtnLoader(false);
                props.updateBulkData({
                    categoryData: res.data.categoryData || []
                })
                historyHandler.pushState(history, 'map-categories-slider');
                const sliderDiv = (sliderRef && sliderRef.current) ? sliderRef.current.sliderContentRef.current : null;
                sliderDiv && sliderDiv.scrollTo(0,0);
                setIsMapCategory(true);
            }
        })
    }
    const onBtnClick = () => {
        // if(Object.values(props.bulkUpload.headerMapping).indexOf("Product Category") != -1 && !isMapCategory){
        //     //If a field is mapped to Product Category, begin category mapping flow.
        //     getCategoryMappingData();
        //     return;
        // }  //category Map got depricated from backend team and now no need of this flow.
        let categoryMap;
        if(isMapCategory){
            categoryMap = {};
            for(let i=0;i<props.bulkUpload.categoryData.length;i++){
                if(!props.bulkUpload.categoryData[i].isMatchFound && !props.bulkUpload.categoryData[i].matchedLeafName){
                    props.showToastMessage({
                        showToastMessage: true,
                        message: 'Select Category to Map',
                        duration: 5000,
                        type: 'error'
                    });
                    let newCatData = [...props.bulkUpload.categoryData]
                    newCatData[i] = {
                        ...newCatData[i],
                        errorMessage: 'Select Category to Map'
                    }
                    props.updateBulkData({
                        categoryData: newCatData
                    })
                    return;
                }
                categoryMap[props.bulkUpload.categoryData[i].leafName] = props.bulkUpload.categoryData[i].leafId;
            }
        }
        let fieldNameToCheck = props.bulkUploadServices ? 'Service Name' : 'Product Name';
        let mrpPriceField = props.transactionType == 'sellonline'
        if (!(Object.values(props.bulkUpload.headerMapping).includes(fieldNameToCheck)) && !categoryWiseBulk) {
            setModalData({
                headerTxt: fieldNameToCheck+' is Not Selected',
                descTxt: fieldNameToCheck+' is mandatory field. ',
                descSubTxt: 'Please map it to one of the column names.'
            })
            setNameValidationModal(true);
            return;
        }else if(transactionType == 'sellonline' && !categoryWiseBulk){
            if(!(Object.values(props.bulkUpload.headerMapping).includes('Price') || Object.values(props.bulkUpload.headerMapping).includes('MRP'))){
                setModalData({
                    headerTxt: 'Price/MRP is Not Selected',
                    descTxt: 'At least one of Price or MRP should be mapped. Please map it to one of the column names.'
                })
            setNameValidationModal(true);
            return;
            }
        }
        var formData = new FormData();
        let url = '/marketplace/static/php/web/b2bWebsite.php?token=' + props.session.token + '&action=updateHeaderMapping&fileId=' + props.bulkUpload.fileId+'&p='+p;
        // if(categoryMap){
        //     url+= '&categoryMap=' + encodeURIComponent(JSON.stringify(categoryMap));
        // }
        if(categoryWiseBulk){
            url+= `&psvNodeId=${catData.psv_node_id}&psvNodeName=${catData.psv_node_name}&keywordId=${catData.keywordId}&keywordName=${catData.name}` ;
        }
        if(props.bulkUploadServices){
            url+='&bulkType=service';
        }
        if(transactionType){
            url+='&transactionType='+transactionType
        }else if (props.session.newProfile == 4 && !props.bulkUploadServices){
            url+='&transactionType=receiveenquiry'
        }
        url+=sourceFlag
        formData.append('headerMapping', encodeURIComponent(JSON.stringify(props.bulkUpload.headerMapping)));
        formData.append('categoryMap', categoryMap ? categoryMap : null);
        setUploadBtnLoader(true);
        axios({
            method: 'POST',
            url: url,
            data: formData,
        }).then((res) => {
            setUploadBtnLoader(false);
            if(isMapCategory){
                history.goBack();
                //Pop map category slider
            }
            if(props.isVendorImport){
                if(res.data.msg == "Success"){
                    let data = JSON.parse(res.data[0]);
                    setCookie('currentStep', '5');
                    setCookie('fileId', (''+data.logId));
                    setCookie('type', props.bulkUploadServices ? 'service' : 'product');
                    props.updateBulkData({currentStep: 4, fileId: data.logId});
                }
                else if(res.data.msg == 'mapPackaging' && res.data.filePackaging){
                    props.updateBulkData({
                        filePackaging: res.data.filePackaging,
                        packagingMapping: {},
                        isMapPackaging: true,
                        templatePackaging: res.data.templatePackaging
                    })
                }
                return;
            }
            setCookie('currentStep', '5');
            setCookie('fileId', (''+props.bulkUpload.fileId));
            setCookie('type', props.bulkUploadServices ? 'service' : 'product');
            setCookie('mongoId',res.data.mongoId);
            props.updateBulkData({...props.bulkUpload,mongoId:res.data.mongoId});
            props.setCurrentStep({currentStep: 5});
        })
    }
    
    const setUploadFailed = (value) => {
        setIsFailed(value);
    }
    const onFileChange = (e) => {
        if(props.bulkUploadServices){
            setChooseFileLoader('service');
        }else{
            setChooseFileLoader('product');
        }
        let fileData = e.target.files[0];
        props.uploadFileForBulkUpload({
            fileData: fileData,
            bulkUploadServices: props.bulkUploadServices,
            contentBlockId: props.contentBlockId,
            supplierId: props.session.supplierId || '',
            selectedOutletId: props.bulkUpload.selectedOutletId,
            transactionType: (props.session.newProfile == 4 && !props.bulkUploadServices) ? 'receiveenquiry' :  transactionType,
            catData: catData,
            categoryWiseBulk:categoryWiseBulk, 
            cb: (isSuccess, msg) => {
                let msgText = 'The uploaded file is either invalid or corrupted. Please upload another file';
                setChooseFileLoader(false);
                if(!isSuccess){
                    dispatch(toastMessageActions.showMessage({
                        message: msg.trim() || msgText,
                        type: 'error',
                        showReduxToast: true
                    }))
                }
                else {
                    if(categoryWiseBulk){                 
                        return;
                    }
                    historyHandler.pushState(history, 'bulk-upload-step-2-slider');
                    setCookie('currentStep', '4');
                    setBackAgain(true);
                    props.setCurrentStep({currentStep: 4});
                }
            }
        });
    }

    useEffect(()=>{
        if(categoryWiseBulk && props.bulkUpload.currentStep == '4'){
            onBtnClick();
        }     
    },[props.bulkUpload.fileId])

    const onFileUploadByAppCB = (value) => {
        console.log(value);
        if (value.event == "uploadStarted"){
            if(props.bulkUploadServices){
                setChooseFileLoader('service');
            }else{
                setChooseFileLoader('product');
            }
        }
        if(value.success && value.data) {
            try {
                let data, rawdata = JSON.parse(value.data);
                data = rawdata[0];
                if(data){
                    let msgText = 'The uploaded file is either invalid or corrupted. Please upload another file';
                    if (data.msg && data.msg == 'Empty file'){
                        msgText = 'No records found. Please check file and re-upload it';
                    }
                    setChooseFileLoader(false);
                    if(!data.isSuccess){
                        dispatch(toastMessageActions.showMessage({
                            message: msgText,
                            type: 'error',
                            showReduxToast: true
                        }))
                    }
                    else {
                        props.updateBulkData({
                            headerMapping: data.headerMapping,
                            mappingOptions: data.mappingOptions,
                            fileId: data.fileId || '',
                            // sampleRow: data.sampleRow
                        })
                        historyHandler.pushState(history, 'bulk-upload-step-2-slider');
                        setCookie('currentStep', '3');
                        setBackAgain(true);
                        props.setCurrentStep({currentStep: 3});
                    }
                }
            }
            catch(e){
                setChooseFileLoader(false);
                console.log(e)
            }
        }
    }
    const uploadBtnClick = (isService) => {
        if(window.jdInterface && window.jdInterface.openFileChooser){
            let ajaxUrl = location.protocol + "//" + location.host + '/marketplace/static/php/web/common_api.php?supplierId=' + props.session.supplierId + '&action=uploadProductFile&isMatchBarcode=true&accountId=' + props.bulkUpload.selectedOutletId + '&importType=advanceImport&source=mobile';
            if(props.bulkUploadServices){
                ajaxUrl = location.protocol + "//" + location.host + '/marketplace/static/php/web/serviceBulkUpload.php?action=uploadFile&contentBlockId='+props.contentBlockId
            }
            ajaxUrl+=sourceFlag
            let object = {
                "uploadSize": "1",
                "ajaxUrl": ajaxUrl,
                // "fileType": "xls,xlsx",
                "fieldName": "file",
                "strType": 'file',
                "mimeTypes": "/"
                // "mimeTypes": [
                //     "application/vnd.ms-excel",
                //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                // ]
            }
            window.jdInterface.openFileChooser(JSON.stringify(object));
            window.jdInterface.appImageSuccess = function (value) {
                onFileUploadByAppCB(value);
            }
        }
        else{
            fileSelector.current.triggerClick(true, true);  
        }
        props.toggleBulkProductService({
            bulkUploadServices : isService ? true : false
        })
    }
    const handleScroll = (e) => {
        let scrollEle = document.getElementsByClassName('bulk-upload-animate-slider')[0];
        if (scrollEle && (scrollEle.scrollTop || scrollEle.scrollTop === 0)){
            setScroll(scrollEle.scrollTop > 5);
        }
    }
    useEffect(() => {
        if(selectTypeQuery?.closeIframe == '1') {
            parent.document.getElementById('omniIframe').style.visibility = 'unset';
            parent.document.body.style.overflow = 'hidden';
            parent.Utills.Loader.hide({loaderType: 'spinner'});
        }
        let currentStep = getCookie('currentStep');
        let fileId = getCookie('fileId');
        let type = getCookie('type');
        let mongoId = getCookie('mongoId');
        if (currentStep && currentStep == '5' && (fileId && mongoId)){
            historyHandler.pushState(history, 'bulk-upload-refresh-slider');
            props.updateBulkData({
                currentStep: 5,
                fileId: fileId,
                bulkUploadServices: (type == 'service'),
                mongoId
            })
        }
        if((!currentStep && !props.bulkUpload.currentStep) || props.bulkUpload.currentStep == '6'){
            props.setCurrentStep({currentStep: 0})
        }
        let scrollEle = document.getElementsByClassName('bulk-upload-animate-slider')[0];
        scrollEle && scrollEle.addEventListener('scroll', handleScroll);
        if (window.jdInterface){
            initialisePhpSession();
        }
        if(window){
            window.appHandler = (jsonStr) => {
                try {
                console.log('callback',jsonStr);
                const transformedJson = JSON.parse(jsonStr);
                const {eventType, redirectionurl} = transformedJson;
                if(redirectionurl){
                    window.location.replace(redirectionurl);
                }else if(eventType == "deviceback"){
                    if (JdLiteInterface && JdLiteInterface.verticalHandler) {
                        const exitJson ={"action":"exit"};
                        JdLiteInterface.verticalHandler(JSON.stringify(exitJson));
                    }
                }
                } catch (e) {
                console.log(e)
                }
            };
            if(props.isJdSourceAndroid){
                pageLoad();
            }else if (props.isJdBusinessIOS) {
				pageLoadForIos();
			}
        }
		return () => {
			scrollEle && scrollEle.removeEventListener('scroll', handleScroll);
		};
    }, []);
    const closeSlider = () => {
        if(props?.selectTypeQuery?.closeIframe == 1) {
            let ele = parent?.document.getElementById('omniIframe');
            parent.document.body.style.overflow = 'unset';
            if(ele?.parentNode && ele?.parentNode?.children && ele?.parentNode?.children?.length){
                ele.parentNode.removeChild(ele);
            }
            return;
        }
        sliderRef.current.toggle(false,{
            onToggleCB : () => {
                updateSliderFlag(false);
                history.goBack();
            }
        });
        props.onHidden && props.onHidden();
    }

    useEffect(() => {
        const skipAttachListener = props.isB2BMobile;
        if ([0,1,3].includes(isProductOnlyProfile)){
            props.setCurrentStep({currentStep: 3})
            if(props.session.newProfile == 3)
            props.toggleBulkProductService({
                bulkUploadServices : true
            })
            if(props.session.newProfile == 0){
                setTransactionType('receiveenquiryNew');
            }else if (props.session.newProfile == 1){
                setTransactionType('sellonlineNew');
            }else if(props.session.newProfile == 4){
                setTransactionType('receiveenquiryNew');
            }
            
        }
        if((props.session.user?.loggedUser?.subType && props.session.user?.loggedUser?.subType == "OBE") && (props.session.bulkUploadProfile)){
            props.toggleBulkProductService({
                bulkUploadServices : true
            })
        }
        if(!skipAttachListener) {
            historyListenerRef.current = history.listen((location, action) => {
                if(action != 'POP'){
                    return;
                }
                let state= location.state;
                handleBack(state);
            })
        }
        return () => {
            if(historyListenerRef.current && !skipAttachListener) {
                historyListenerRef.current();
            }
        }
    },[]);
    useEffect(() => {
		sliderRef.current.toggle(true,{
            onToggleCB : () => {
                updateSliderFlag(true)
            }
        });
        props.updateBulkStatus && props.updateBulkStatus(false);
        if(!props.isVendorImport && !props.deviceData.isMobile) {
            historyHandler.pushState(history, 'bulk-upload-slider')
        }
        const attachListener = props.isB2BMobile;
        if(attachListener) {
            historyListenerRef.current = history.listen((location, action) => {
                if(action != 'POP'){
                    return;
                }
                let state= location.state;
                handleBack(state);
            })
        }
        return () => {
            if(historyListenerRef.current && attachListener) {
                historyListenerRef.current();
            }
        }
	}, []);
    
    const handleScrollWeb = (scrollAmt) => {
        if (isMobile){
            return;
        }
        setScroll(scrollAmt.currScroll.scrollTop > 5);
    }
    const setAutoUpdateProdInfo = (value, mode) => {
        if(mode == 'Barcode'){
            setUpdateViaBarcode(value);
        }else{
            setUpdateViaProdName(value);
        }
    }
    const onCrossClick = () => {
        historyHandler.closeCurrent();
        setBackAgain(false);
        props.setCurrentStep({currentStep: 0});
        props.onHidden && props.onHidden();
        props.clearBulkUploadData && props.clearBulkUploadData();
    }
    const [updateViaBarcode, setUpdateViaBarcode] = useState(true);
    const [updateViaProdName, setUpdateViaProdName] = useState(false);
    let isMobile = props.deviceData.isMobile;
    let currentStep = (props.bulkUpload.currentStep || props.bulkUpload.currentStep === 0) ? props.bulkUpload.currentStep : 1;
    if(!props.isVendorImport|| (props.outletData && props.outletData.length <= 1)) {
        if(currentStep === 0 ) {
            props.setCurrentStep({currentStep: (!profileObject.isSer) || params.type == 'product' ? 2 : 1});
        }
    }
    let headerText = `Bulk Upload ${props.bulkUploadServices ? 'Services' : 'Products'}`;
    if(currentStep === 1 ) {
        headerText = `Bulk Upload Products / Services`
    }
    if((!profileObject.isRE && !profileObject.isSO && profileObject.isSer)){
        headerText = `Bulk Upload Services`
    }
    const sliderRef = React.useRef(null);
    let sliderBodyRef = React.useRef(null);
    useOnScroll({
		callback: (e, scrollAmt) => {
            handleScrollWeb(scrollAmt);
        },
        element: sliderShown ? sliderBodyRef : null,
        deps:[sliderShown]
	});
    let finalLeftIcon = isMobile ? leftIcons : leftIconsWeb;
    if(currentStep == 6){
        finalLeftIcon = finalLeftIcon.filter(cur => {
            if(!cur.className.toLowerCase().includes('hdrback')) {
                return cur;
            }
        })
    }
    
    return (
        <>
        <AnimateSlider
            slideDirection= 'right'
            disableAnimation={props.isVendorImport}
            className={`bulk-upload-animate-slider ${ props.deviceData.isIphone ? "isIphone" : ""}`}
            ref={sliderRef}
            width={isMobile ? '100%' : '320px'}
            enableHeader
            sliderHeader={<SliderHeader
                className={'bulk-upload-header' + (isScroll?' scrolled':'')}
                heading={headerText}
                headingClass='bulk-upload-heading'
                leftIcons={finalLeftIcon}
                rightIcons={isMobile ? ((currentStep <= 1 || (props.session.bulkUploadProfile == 1 && currentStep != 4))? rightIcons: []) : rightIconsWeb}
                headingIconClass='header-class'
                variant='secondary'
            />}
        >
        <div ref={sliderBodyRef} className={`bulk-upload-container ${isMobile ? 'isMobile': 'isWeb'}`}>
            <div className='bulk-upload-holder'>
                <CSSTransform>
                    <div className={`bulk-upload-body ${noAnimate? 'no-animate': ''}`}>
                        <div className={`progress-status ${isOutletSelectRequired ? 'four-dot':''}`}>
                            {(isOutletSelectRequired) &&
                                <>
                                    <div className={`progress-circle ${currentStep > 0 ? 'completed':''} ${currentStep == 0 ? 'current':''}`}>
                                        {currentStep > 0 ? <i className='icon-Checkmark'></i>: null}
                                    </div>
                                    <div className={`progress-circle-connect ${currentStep > 0 ? 'filled':''}`}></div>
                                </>
                            }
                               {!(profileObject.isSer) ? null : <div className={`progress-circle ${currentStep > 1 ? 'completed':''} ${currentStep == 1 ? 'current':''}`}>
                                 {currentStep > 1 ? <i className='icon-Checkmark'></i>: null}
                            </div>}
                            {!(profileObject.isSer) ? null : <div className={`progress-circle-connect ${currentStep > 1 ? 'filled':''}`}></div>}
                            {(!(!profileObject.isRE && !profileObject.isSO && profileObject.isSer)) ? 
                                <>
                                    <div className={`progress-circle ${currentStep > 2 ? 'completed':''} ${currentStep == 2 ? 'current':''}`}>
                                        {currentStep > 2 ? <i className='icon-Checkmark'></i>: null}
                                    </div>
                                    <div className={`progress-circle-connect ${currentStep > 2 ? 'filled':''}`}></div>
                                </> : null}
                            <div className={`progress-circle ${currentStep > 3 ? 'completed':''} ${currentStep == 3 ? 'current':''}`}>
                                {currentStep > 3 ? <i className='icon-Checkmark'></i>: null}
                            </div>
                            {
                                <>
                                    <div className={`progress-circle-connect ${currentStep > 3 ? 'filled':''}`}></div>
                                    <div className={`progress-circle ${currentStep > 4 ? 'completed':''} ${currentStep == 4 ? 'current':''}`}>
                                        {currentStep > 4 ? <i className='icon-Checkmark'></i>: null}
                                    </div>
                                </>
                            }
                            <div className={`progress-circle-connect ${currentStep > 4 ? 'filled':''}`}></div>
                            <div className={`progress-circle ${isFailed? 'failed ': ''} ${currentStep == 6 ? 'completed':''} ${currentStep == 5 ? 'current':''}`}>
                                {currentStep == 6 && !isFailed ? <i className='icon-Checkmark'></i>: null}
                                {currentStep == 6 && isFailed ? <i className='icon-alert_outline2'></i>: null}
                            </div>
                        </div>

                        {(currentStep == 2 && (Number(isProductOnlyProfile) == 2)) ? <div className='step2-transaction-type'>
                            Select the Transaction Type Suitable for Your Business
                        </div>:""}
                        {(currentStep == 3 && (Number(isProductOnlyProfile) != 0)) ? <div className='step2-transaction-type'>
                            Select the Suitable Upload Type
                        </div>:""}
                        {(currentStep === 0 && isOutletSelectRequired) ?
                            <OutletSelectDiv
                                selectedOutletId={selectedOutletId}
                                setSelectedOutletId={setSelectedOutletId}
                                outletData={props.outletData || []}
                            />
                            :null
                        }
                        {currentStep == 1 ?
                            <UploadPrompt
                                {...props}
                                isProductOnlyProfile={isProductOnlyProfile}
                                // transactionType={"receiveenquiryNew"}
                                // setTransactionType={setTransactionType}
                                uploadBtnClick={uploadBtnClick}
                                showLoader={showChooseFileLoader}
                            />
                            : null
                        }
                        {currentStep == 2 ?
                            <TransactionType 
                                {...props}
                                uploadBtnClick={uploadBtnClick}
                                showLoader={showChooseFileLoader}
                                transactionType={transactionType}
                                setTransactionType={setTransactionType}
                                isProductOnlyProfile={isProductOnlyProfile}
                            />
                            : null
                        }
                        {currentStep == 3 ? 
                            <SellOnlineStep
                                {...props}
                                uploadBtnClick={uploadBtnClick}
                                showLoader={showChooseFileLoader}
                                transactionType={transactionType}
                                setTransactionType={setTransactionType}
                                showCategoryWiseBulk={showCategoryWiseBulk}
                                isProductOnlyProfile={isProductOnlyProfile}
                            />
                            : null
                        }
                        {currentStep == 4 && !categoryWiseBulk? 
                            <MapFields
                                {...props}
                                fieldsData={props.bulkUpload.headerMapping}
                                onBtnClick={onBtnClick}
                                updateViaBarcode={updateViaBarcode}
                                updateViaProdName={updateViaProdName}
                                setAutoUpdateProdInfo={setAutoUpdateProdInfo}
                                optionsList={props.bulkUpload.mappingOptions}
                                handleChange={(e, fieldId) => handleChange(e, fieldId)}
                                isMapCategory={isMapCategory}
                                openCatSlider={(index)=>{
                                    setCatSlider({
                                        show: true,
                                        index,
                                        searchText: props.bulkUpload.categoryData[index].isMatchFound ? props.bulkUpload.categoryData[index].matchedLeafName : props.bulkUpload.categoryData[index].leafName
                                    })
                                }}
                            />
                            :null
                        }    
                        {currentStep == 4 && categoryWiseBulk? 
                            <CategoryWiseBulk
                                {...props}
                                setCatData={setCatData}
                                catData={catData}
                                uploadBtnClick={uploadBtnClick}
                                isUploadBtnLoader={isUploadBtnLoader}
                                transactionType={transactionType}
                                setBypassScreen={()=>setBypassScreen(true)}
                            />
                            : null
                        }
                        {currentStep >= 5 ?
                            <UploadProgress
                                {...props}
                                toggleRedirectToProducts={(value) => {
                                    redirectedToProducts.current = value;
                                }}
                                sendToFirstStep={() => {
                                    if (props.isB2BMobile) {
                                        // window.history.back();
                                        handleBack('', true);
                                        showCategoryWiseBulk(false);
                                        setCatData('')
                                    } else {
                                        handleBack('', true);
                                        setCatData('')
                                    }
                                }}
                                toggleBulkDiscountModal={toggleBulkDiscountModal}
                                setCookie={(name, value) => {setCookie(name, value)}}
                                setUploadFailed={(value) => { setUploadFailed(value) }}
                                currentStep={currentStep}
                                transactionType={transactionType}
                                isProductOnlyProfile={isProductOnlyProfile}
                                selectTypeQuery={selectTypeQuery}
                            />
                            : null
                        }
                        {showCatSlider.show ? 
                            <CategorySearchSlider 
                                onSelectCategory={(e, catData)=>{
                                    let newCatData = [...props.bulkUpload.categoryData]
                                    newCatData[showCatSlider.index] = {
                                        ...newCatData[showCatSlider.index],
                                        isMatchFound: true,
                                        matchedLeafName: catData.name,
                                        leafId: catData.id,
                                        errorMessage: ''
                                    }
                                    props.updateBulkData({
                                        categoryData: newCatData
                                    })
                                    setCatSlider({show: false})
                                }}
                                closeSlider={() => setCatSlider({show: false})}
                                catSliderShown={showCatSlider.show}
                                categoryName={showCatSlider.searchText}
                                productName={showCatSlider.searchText}
                                customClass='bulk-category-search'
                                fromBulkUpload={true}
                            /> : null
                        }
                        <FileSelector 
                            onChange={onFileChange} 
                            ref={fileSelector}
                            accept={props.acceptedFileTypes || accept}
                        />
                    </div>
                </CSSTransform>
            </div>
        </div>
        </AnimateSlider>
        {currentStep == 4 && !categoryWiseBulk ?
            <div className='upload-prod'>
                <Button
                    onClick={onBtnClick}
                    raised
                    showLoader={isUploadBtnLoader}
                    size='lg'
                >
                    {isMapCategory ? 'Continue' : `Upload ${props.bulkUploadServices ? 'Services' : 'Products'}`}
                </Button>
            </div>
            : null
        }
        {(currentStep == 0 && props.outletData && !historySliderOpen) &&
            <div className='save-outlet'>
                <Button
                    onClick={saveOutlet}
                >
                    Continue
                </Button>
            </div>
        }
        {nameValidationModal &&
            <Modal 
                onHidden={() => setNameValidationModal(false)}
                backdropStatic
                settings={{
                    variant:'action '+style['name-valid-modal'],
                    class: `${!props.deviceData.isMobile ? 'name-valid-modal-web' : ''}`
                }}
            >
                <Modal.CloseIcon />
                <Modal.Header className='name-valid-modal-header'>
                    {modalData.headerTxt}
                </Modal.Header>
                <Modal.Body className='name-valid-modal-body'>
                    <div>{modalData.descTxt}</div>
                    <div>{modalData.descSubTxt}</div>
                </Modal.Body>
                <Modal.Footer className='name-valid-modal-footer'>
                    <Button size='lg' clickHandler={() => window.history.back()}>Okay, Got it</Button>
                </Modal.Footer>
            </Modal>
        }
        {bulkDiscountModal.show ?
            <BulkDiscountActionModal
                onHidden={()=>toggleBulkDiscountModal({show:false})}
                title={'Discounted Products'}
                data={bulkDiscountModal.data}
                btnName= {'Okay, Got It'}
                variant={'primary'}
                onclick={()=>toggleBulkDiscountModal({show: false})}
            />
            : null
        }
        {
            historySliderOpen && (
                <BulkUploadHistorySlider 
                    onHidden={() => updateHistorySlider(false)}
                    outletData={props.outletData}
                    onCrossClick={onCrossClick}
                />
            )
        }
        </>
    )
};

const mapStateToProps = (state,props) => {
	return {
        session: state.session,
        outletData: state.permissions.outletData,
        isVendorImport: state.session.source == 'webstore',
        isB2BMobile: state.session.source === 'b2b' && state.library.deviceData.isMobile,
        deviceData: state.library.deviceData,//state.deviceData,
        bulkUpload: state.bulkUpload,
        isMaintainProductSku: state.permissions.isMaintainProductSku,
        bulkUploadServices: state.bulkUpload.bulkUploadServices,
        user: state.session.user,
        isSourceJustdial: state.session.isJdSourceAndroid || state.session.isJdSourceIOS,
        isJdBusinessIOS: state.session.isJdBusinessIOS,
        isJdSourceIOS: state.session.isJdSourceIOS,
        isJdSourceAndroid: state.session.isJdSourceAndroid
	};
};

export default connect(mapStateToProps, {
    uploadFileForBulkUpload,
    showToastMessage: toastMessageActions.showMessage,
    setCurrentStep,
    updateBulkData,
    clearBulkUploadData,
    updateHeaderMapping,
    setTabStatus,
    setPreviousTabIndex,
    toggleBulkProductService
})(BulkUploadSlider);